import React, { ReactNode } from 'react';

import { Accordion } from '../../components/Accordion';
import { Image } from '../../components/Image';
import ChevronRightIcon from '../../foundations/pictograms/chevron.svg';
import { textBodyLarge, textBodySmall } from '../../styles/typography';
import { classNames } from '../../utils/style';
import { ImageProps } from '../../components/Image/types';

export interface AccordionElementProps {
  title: string;
  text?: ReactNode;
  button?: ReactNode;
  image?: ImageProps;
  isOpen: boolean;
  setOpen: any;
  index: number;
  className?: string;
  onClick?: any;
  toggleProps?: any;
}

export const AccordionElement = ({
  title,
  text,
  button,
  image,
  isOpen = false,
  setOpen,
  className,
  onClick,
  toggleProps,
  index = 0,
}: AccordionElementProps) => {
  const content = (
    <div className="px-24 pb-24">
      {text && <div className={textBodySmall}>{text}</div>}
      {button && button}
      {image && (
        <div className="mt-20 md:hidden">
          <Image
            {...image}
            sizes={[
              '(max-width: 350px) 270px',
              '(max-width: 500px) 420px',
              '675px',
            ]}
          />
        </div>
      )}
    </div>
  );

  return (
    <Accordion
      question={title}
      answer={content}
      index={index}
      open={isOpen}
      onClick={onClick}
      setOpen={() => setOpen(index)}
    >
      <div
        className={classNames(
          className,
          'flex-1',
          'mb-8 overflow-hidden rounded-12 hover:bg-neutral-21',
          isOpen && 'bg-neutral-21',
        )}
      >
        <Accordion.Button
          className={classNames(
            'p-24 w-full flex justify-between text-left',
            textBodyLarge,
            isOpen ? 'pb-16' : 'text-neutral-51',
          )}
          {...toggleProps}
        >
          {title}
          <div className="w-20 ml-12">
            <ChevronRightIcon
              className={classNames(
                isOpen ? 'transform rotate-180' : 'text-blue-101',
                'duration-200 transition fill-current',
              )}
            />
          </div>
        </Accordion.Button>
        <Accordion.Content animOnClose={true} className="-top-16" />
      </div>
    </Accordion>
  );
};
